import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS = [
  { path: '/admin', label: 'Dashboard' },
  { path: '/admin/users', label: 'Users' },
  { path: '/admin/sessions', label: 'Sessions' },
  { path: '/admin/security', label: 'Security' },
  { path: '/admin/applications', label: 'Applications' },
];

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <nav className="admin-sidebar">
        <div className="admin-sidebar-header">
          <Link to="/account" className="admin-brand">
            <span className="admin-brand-raike">Raike</span>
            <span className="admin-brand-amp">&amp;</span>
            <span className="admin-brand-sons">Sons</span>
          </Link>
          <div className="admin-brand-sub">Administration</div>
        </div>

        <div className="admin-nav-section">
          {NAV_ITEMS.map(item => (
            <Link key={item.path} to={item.path}
              className={`admin-nav-link ${location.pathname === item.path ? 'active' : ''}`}>
              {item.label}
            </Link>
          ))}
        </div>

        <div className="admin-sidebar-footer">
          <Link to="/account" className="admin-nav-link">My Account</Link>
          <a href="#" onClick={handleLogout} className="admin-nav-link" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.59L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
            Sign Out
          </a>
        </div>
      </nav>
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
}
